import React from 'react';

const IconCheckCircleFill = ({ size = 20, color = '#FFFFFF', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 22 20" 
    fill="none" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M21.44 9.9999C21.44 15.4315 16.6405 19.8348 10.72 19.8348C4.79951 19.8348 0 15.4315 0 9.9999C0 4.56826 4.79951 0.165039 10.72 0.165039C16.6405 0.165039 21.44 4.56826 21.44 9.9999ZM16.1206 6.27454C15.7282 5.91447 15.0918 5.91447 14.6993 6.27454C14.6899 6.28324 14.681 6.29245 14.6727 6.30212L10.0197 11.7416L7.21439 9.1679C6.82192 8.80783 6.18559 8.80783 5.79311 9.1679C5.40063 9.52797 5.40063 10.1118 5.79311 10.4718L9.33935 13.7253C9.73183 14.0853 10.3682 14.0853 10.7606 13.7253C10.7694 13.7172 10.7776 13.7088 10.7853 13.6999L16.1349 7.56512C16.5131 7.20412 16.5083 6.6302 16.1206 6.27454Z" 
      fill={color}
    />
  </svg>
);

export default IconCheckCircleFill;
